import styled from "styled-components";
import colors from "../../../theme/colors";

interface IconsTopBarProps {
  isSelected: boolean;
}

export const IconContainer = styled.div<IconsTopBarProps>`
  width: 100%;
  padding: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: ${(props) => props.isSelected && colors.white};
  cursor: pointer;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  background: ${(props) => props.theme.colors.background};
  border-radius: 10px 10px 0 0;

  & :first-child {
    border-radius: 10px 0 0;
  }

  & :last-child {
    border-radius: 0 10px 0 0;
  }

  @media screen and (min-width: 851px) {
    display: none;
  }
`;
